import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'
import NameValueTableRow, {
  GROUPED_STATIC_TEXT_ROLE
} from '../../../../components/ui-components/NameValueTableRow'
import RenderHTML from '../../../../components/ui-components/RenderHTML'
import { ChevronIcon } from '../ChevronIcon'

type WithdrawalsSummaryCardProps = {
  totalWithdrawal: number
  totalRealisedGains: number
  netRealisedLtcg: number
  netRealisedStcg: number
  onNetRealisedLtcgClick?: () => void
  onNetRealisedStcgClick?: () => void
}

export function WithdrawalsSummaryCard({
  totalWithdrawal,
  totalRealisedGains,
  netRealisedLtcg,
  netRealisedStcg,
  onNetRealisedLtcgClick,
  onNetRealisedStcgClick
}: WithdrawalsSummaryCardProps) {


  return (
    <section className="shrink-0 bg-white rounded-[16px] border border-[#EBF2F2] p-4 mb-5 w-full">
      <div
        role={GROUPED_STATIC_TEXT_ROLE}
        className="pb-4 border-b border-[#F0F4F7]"
        aria-label={`Total withdrawals, ${formatAmountWithSign(totalWithdrawal)}`}
      >
        <div aria-hidden='true' className="text-[14px] font-[400] text-[#6A6E6E]">Total withdrawals</div>
        <div aria-hidden='true' className="text-[22px] font-[500] text-[#232323] pt-1">
          {formatAmountWithSign(totalWithdrawal)}
        </div>
      </div>
      <div className="flex flex-col text-[14px] font-[400] pt-4">
        <NameValueTableRow
          name="Total realised gains"
          value={formatAmountWithSign(totalRealisedGains)}
          groupForAccessibility
          nameValueRowClassName="flex items-center py-1"
          nameClassName="text-[#6A6E6E] font-[400]"
          valueClassName="!font-[500] !text-[14px] !text-[#232323] text-right"
        />
        <NameValueTableRow
          name={`Net realised LTCG, ${formatAmountWithSign(netRealisedLtcg)}`}
          value=""
          nameValueRowClassName="flex items-center py-1"
          nameContent={
            <button
              type='button'
              onClick={onNetRealisedLtcgClick}
              aria-label={`Net realised LTCG, ${formatAmountWithSign(netRealisedLtcg)}`}
              className="flex items-center gap-1 text-[14px] font-[400] text-[#6A6E6E] cursor-pointer bg-transparent border-none px-0 py-[4px] -my-[4px]"
            >
              <span aria-hidden='true'>Net realised LTCG</span>
              <span aria-hidden='true'>
                <RenderHTML innerHTMLText={ChevronIcon} />
              </span>
            </button>
          }
          valueContent={
            <div aria-hidden='true' className="font-[500] text-[14px] text-[#232323] text-right">
              {formatAmountWithSign(netRealisedLtcg)}
            </div>
          }
        />
        <NameValueTableRow
          name={`Net realised STCG, ${formatAmountWithSign(netRealisedStcg)}`}
          value=""
          nameValueRowClassName="flex items-center py-1"
          nameContent={
            <button
              type='button'
              onClick={onNetRealisedStcgClick}
              aria-label={`Net realised STCG, ${formatAmountWithSign(netRealisedStcg)}`}
              className="flex items-center gap-1 text-[14px] font-[400] text-[#6A6E6E] cursor-pointer bg-transparent border-none px-0 py-[4px] -my-[4px]"
            >
              <span aria-hidden='true'>Net realised STCG</span>
              <span aria-hidden='true'>
                <RenderHTML innerHTMLText={ChevronIcon} />
              </span>
            </button>
          }
          valueContent={
            <div aria-hidden='true' className="font-[500] text-[14px] text-[#232323] text-right">
              {formatAmountWithSign(netRealisedStcg)}
            </div>
          }
        />
      </div>
    </section>
  )
}

export function formatAmountWithSign(value: number): string {
  if (value > 0) return `${roundOffAndFormatNumberWithCurrency(value)}`
  if (value < 0) return `- ${roundOffAndFormatNumberWithCurrency(Math.abs(value))}`
  return `${roundOffAndFormatNumberWithCurrency(0)}`
}
